import BasePageSection from "../BasePageSection";
import { SanityImageSection } from "@sourceful/shared-types";
import { getSanityImgUrl } from "@lib/sanity";
import { css } from "@sourceful/shared-components";
import { IMAGE_DIMENSION_IMAGE_SECTION_MAX_WIDTH } from "@lib/utils/imageDimensions";

const imgContainerCss = css({
  display: "flex",
  justifyContent: "center",
});

const imgCss = css({
  maxWidth: "100%",
});

interface ImageSectionProps {
  section: SanityImageSection;
}

const ImageSection = ({ section }: ImageSectionProps) => {
  const hasVisibleTitle = section.title && section.showTitle;

  // This will limit the image size if its MASSIVE to a maximum of 2000px in this case
  // If its smaller it will just use what it has, so the component will need to make sure it centers it in the space
  // Editors should upload a BIG image and let Sanity do the work
  const imageUrl = getSanityImgUrl(section.image.asset._ref, base =>
    base.width(IMAGE_DIMENSION_IMAGE_SECTION_MAX_WIDTH).fit("max")
  );

  if (!imageUrl) {
    return null;
  }

  return (
    <BasePageSection section={section}>
      <div
        className={imgContainerCss({
          css: {
            mbs: hasVisibleTitle ? "$block_m3" : "",
          },
        })}
      >
        <img
          src={imageUrl}
          className={imgCss()}
          alt={section.image.asset?.altText || ""}
          loading="lazy"
        />
      </div>
    </BasePageSection>
  );
};

export default ImageSection;
